import type { ModuleFederationRuntimePlugin } from '@module-federation/enhanced/runtime'

const ENVIRONMENTS = ['staging', 'uat', 'beta', 'pilot']

const ENVIRONMENT_BUCKETS: Record<string, string> = {
  microentitiesassets: 'entities.shipx.cc'
}

const resolveEnvironment = () => {
  const { hostname } = globalThis.location
  return ENVIRONMENTS.find(environment => hostname.includes(environment))
}

const mfRemoteEnvironment = (): ModuleFederationRuntimePlugin => ({
  name: 'mf-remote-environment',
  beforeInit(args) {
    const environment = resolveEnvironment()
    if (!environment) return args

    args.userOptions.remotes = args.userOptions.remotes?.map(remote => {
      const bucket = ENVIRONMENT_BUCKETS[remote.name]
      if (!bucket || !('entry' in remote)) return remote
      return {
        ...remote,
        entry: `https://storage.googleapis.com/${environment}-${bucket}/mf-manifest.json`
      }
    })

    return args
  }
})

export default mfRemoteEnvironment
